import React, { useState } from 'react';
import { Modal } from 'antd';
import ContentQuiz from './index';

const ContentQuizModal = ({ open, onClose, courseId, contentId, course, onQuizCompleted }) => {
  const [isQuizActive, setIsQuizActive] = useState(false);

  return (
    <Modal
      open={open}
      onCancel={() => {
        if (!isQuizActive && onClose) {
          onClose();
        }
      }}
      closable={!isQuizActive}
      maskClosable={!isQuizActive}
      keyboard={!isQuizActive}
      footer={null}
      width={920}
      destroyOnClose
      centered
      className="content-quiz-modal-container"
      bodyStyle={{ padding: 0, maxHeight: '85vh', overflowY: 'auto' }}
    >
      <ContentQuiz
        modalMode={true}
        propCourseId={courseId}
        propContentId={contentId}
        propCourse={course}
        onClose={onClose}
        onQuizCompleted={onQuizCompleted}
        onQuizStateChange={(active) => setIsQuizActive(active)}
      />
    </Modal>
  );
};

export default ContentQuizModal;
